var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConversation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01025 8.1C2.01025 4.63438 4.91569 2.01025 8.5 2.01025C11.9764 2.01025 14.8897 4.52704 14.8897 8C14.8897 11.4718 11.8776 14.0898 8.4 14.0898C7.26352 14.0898 6.15626 13.7122 5.24523 13.2399L2.78649 14.0595C2.58142 14.1278 2.35538 14.0785 2.19741 13.931C2.03945 13.7834 1.97487 13.5612 2.02912 13.352L2.66785 10.8883C2.19362 10.0317 2.01025 9.09336 2.01025 8.1ZM8.5 3.18975C5.48431 3.18975 3.18975 5.36563 3.18975 8.1C3.18975 9.01922 3.37267 9.80355 3.8001 10.4874C3.88592 10.6247 3.91151 10.7913 3.87087 10.948L3.44329 12.5973L5.1135 12.0405C5.27033 11.9882 5.4419 12.0042 5.5864 12.0845C6.43486 12.5558 7.43467 12.9103 8.4 12.9103C11.3224 12.9103 13.7102 10.7282 13.7102 8C13.7102 5.27297 11.4236 3.18975 8.5 3.18975Z",
    fill: "#FF8731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 20.3C20.8 20.5 20.7 20.6 20.5 20.5L18.1 19.8C17.2 20.3 16.1 20.7 15 20.7C11.8 20.7 9.1 18.3 9.1 15.2C9.1 12.1 11.7 9.70001 15 9.70001C18.2 9.70001 20.9 12.1 20.9 15.2C20.9 16.2 20.7 17.1 20.2 17.9L20.8 20.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.2579C11.969 10.2579 9.65795 12.4459 9.65795 15.2C9.65795 17.9482 12.0626 20.142 15 20.142C15.9726 20.142 16.9778 19.7852 17.829 19.3122L18.0326 19.1991L20.1004 19.8022L19.6012 17.8053L19.7269 17.6043C20.1582 16.9141 20.342 16.1236 20.342 15.2C20.342 12.4518 17.9374 10.2579 15 10.2579ZM8.54205 15.2C8.54205 11.7541 11.431 9.14203 15 9.14203C18.4626 9.14203 21.4579 11.7482 21.4579 15.2C21.4579 16.1946 21.2734 17.132 20.7968 17.9865L21.3579 20.2313V20.3C21.3579 20.4549 21.3248 20.7601 21.0598 20.9588C20.7879 21.1627 20.4902 21.1027 20.3058 21.0245L18.1632 20.3996C17.2508 20.876 16.1394 21.2579 15 21.2579C11.5374 21.2579 8.54205 18.6518 8.54205 15.2Z",
    fill: "#1DA4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 16.2C13.2418 16.2 13.6 15.8418 13.6 15.4C13.6 14.9581 13.2418 14.6 12.8 14.6C12.3582 14.6 12 14.9581 12 15.4C12 15.8418 12.3582 16.2 12.8 16.2Z",
    fill: "#FF8731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1 16.2C15.5418 16.2 15.9 15.8418 15.9 15.4C15.9 14.9581 15.5418 14.6 15.1 14.6C14.6582 14.6 14.3 14.9581 14.3 15.4C14.3 15.8418 14.6582 16.2 15.1 16.2Z",
    fill: "#FF8731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 16.2C17.8418 16.2 18.2 15.8418 18.2 15.4C18.2 14.9581 17.8418 14.6 17.4 14.6C16.9582 14.6 16.6 14.9581 16.6 15.4C16.6 15.8418 16.9582 16.2 17.4 16.2Z",
    fill: "#FF8731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 9.19998C6.64183 9.19998 7 8.8418 7 8.39998C7 7.95815 6.64183 7.59998 6.2 7.59998C5.75817 7.59998 5.4 7.95815 5.4 8.39998C5.4 8.8418 5.75817 9.19998 6.2 9.19998Z",
    fill: "#1DA4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 9.19998C8.84183 9.19998 9.2 8.8418 9.2 8.39998C9.2 7.95815 8.84183 7.59998 8.4 7.59998C7.95817 7.59998 7.6 7.95815 7.6 8.39998C7.6 8.8418 7.95817 9.19998 8.4 9.19998Z",
    fill: "#1DA4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 9.19998C11.2418 9.19998 11.6 8.8418 11.6 8.39998C11.6 7.95815 11.2418 7.59998 10.8 7.59998C10.3582 7.59998 10 7.95815 10 8.39998C10 8.8418 10.3582 9.19998 10.8 9.19998Z",
    fill: "#1DA4AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4,
    height: 19.2,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.5ad41edee296b872dc859f1425401a67.svg";
export { ForwardRef as ReactComponent };